import React from 'react';
import go1 from '../assets/images/guesthouse/1.jpg';
import go2 from '../assets/images/guesthouse/2.jpg';
import go3 from '../assets/images/guesthouse/3.jpg';
import go4 from '../assets/images/guesthouse/4.jpg';
import go5 from '../assets/images/guesthouse/5.jpg';
import go6 from '../assets/images/guesthouse/6.jpg';
import go7 from '../assets/images/guesthouse/7.jpg';
import go8 from '../assets/images/guesthouse/8.jpg';
import go9 from '../assets/images/guesthouse/9.jpg';
import './Goshala.css';


function GuestHouse() {
    return (
        <section className="goshala-section">
            <div className="container">
                <br></br>
                <h1 className="goshala-title text-center">🏨 ISKCON Ujjain Guest House 🏨</h1>
                <br></br>

                <p>
                    The guest house hosts both devotee and prospective devotee guests from around the globe. There are 21 luxurious marble rooms with comfortable furniture and individual toilet facilities. The rooms are quite spacious and the highest standards of cleanliness are maintained. The guest house hosts a variety of devotees including Sannyasis, GBC members, Prabhupada disciples, gurus and other visiting devotees from places like Mumbai, Delhi, Surat and Mayapur. All the rooms have split Air Conditioner facility and wide balconies overlooking the garden and the temple.
                </p>
                <p>
                    The auditorium has a capacity of 400 to host various spiritual and cultural programs on festivals, seminars and other events.

                </p>
            </div>
            <div className="guesthouse-flex">
                
           
                <div className="booking-box">
                    <h2 className="booking-title">Online Booking</h2>
                    <hr />
                    <ul className="booking-info">
                        <li><span className="icon">🟢</span> Checkin - 10:00 AM</li>
                        <li><span className="icon">🔚</span> Checkout - 09:00 AM</li>
                        <li><span className="icon">✅</span> 24/7 Reception</li>
                    </ul>
                    <a target="_blank" href="https://server.iskconujjain.com/ics/facility/userBook" className="book-btn">BOOK HERE</a>

                    <p className="note"><em>Max 3 Days stay in One Life Member Card</em></p>
                    <p className="note">Cancellation won’t work if canceled within 02 Days of the Checkin Date</p>
                    <p className="contact">Contact Info:<br /> +91 94246 98700 , 0734 351 0005</p>
                    <a target="_blank" href="https://server.iskconujjain.com/ics/facility/userBookCancel" className="cancel-btn">CANCEL BOOKING</a>
                </div>

                     </div><div className="gallery-masonry">
                    <img src={go1} alt="Cow resting under tree" />
                    <img src={go3} alt="Devotees caring for cows" />
                    <img src={go4} alt="Devotees caring for cows" />
                    <img src={go5} alt="Devotees caring for cows" />
                    <img src={go2} alt="Cows feeding in barn" />
                    <img src={go6} alt="Devotees caring for cows" />
                    <img src={go7} alt="Devotees caring for cows" />
                    <img src={go8} alt="Devotees caring for cows" />
                    <img src={go9} alt="Devotees caring for cows" />
                </div>   

        </section>
    );
}

export default GuestHouse;
